// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12974":"skin-copy","50169":"aria-labels"}[chunkId] || chunkId) + "-" + {"12974":"7e059b709a4b05312454","38779":"8d94872edbc834bb2054","50169":"8f723e069816968c09f4","54586":"61a624bf3ea7503b775e","66110":"e2d850cab6af339cdfbd","86043":"56a07e87961d256ab231"}[chunkId] + ".min.js";
};